<!--
================================================
Un composant qui affiche une modal pour la confirmation de la suppression d'un projet

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/projects

LIMITATION DU COMPOSANT :

    * Sur la balise form le "v-on:submit.prevent" évite un comportement de rechargement de la page à la soumission du form.  @link https://forum.vuejs.org/t/modal-form-submit-always-reloads-page/1279

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
<!--        {{'Hello ! :) I am ' + $options.name}}-->

    <div class="modal modalDeleteItem " id="ModalDeleteProjectComp"  v-bind:class="[{ 'darkMode':themeToDisplay=='dark',  'is-active': isVisible }] " v-on:keyup.esc="hideModal()">
        <!--ajouter la classe is-active sur.modal pour l'afficher-->
        <div class="modal-background"></div>
        <div class="modal-card" >
            <header class="modal-card-head">
                <font-awesome-icon :icon="['far', 'folder-open']" class="icon"/>

                <p class="modal-card-title has-text-left">
                    {{$t('SupprimerUnProjet')}}
                </p>
                <button v-on:click="hideModal()" id="closeModalDeleteProject" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">

                <h3 class="warningTitle">
                    <font-awesome-icon :icon="['fas', 'bomb']" class="icon"/>
                    {{$t('attention')}}
                </h3>
                <p v-if="project!=null" v-html="$t('avertissementSuppressionProjet',{projectName:project.name})" class="warningText has-text-left" id="error_ModalDeleteProject_name"></p>

            </section>

            <!--------------------------------------------------------->
            <footer class="modal-card-foot">
                <a v-on:click="hideModal()" class="button is-text cancelLink" v-focus tabindex="0" id="cancelModalDeleteProject">{{$t("annuler")}}</a>
                <a v-on:click="deleteProject(project)" v-on:keypress.enter="deleteProject(project)" v-bind:class="{'is-loading':isSubmiting}"
                        v-bind:disabled="isSubmiting" tabindex="0"
                        class="button is-danger validBtn " id="submitModalDeleteProject">{{$t("supprimer")}}</a>
            </footer>

        </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";
    // import _ from 'lodash'

    export default {
        name: 'ModalDeleteProjectComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TrackingMixin],

        directives: {
            /**
             * Permet de focuser un élément avec v-focus (requiert l'attribut "tabindex" sur la cible)
             * @link https://vuejs.org/v2/guide/custom-directive.html
             **/
            focus: {
                update: function (el) {
                    el.focus()
                }
            }
        },

        components: {},

        props: {
        },
        data: function () {
            return {
                project: null , // Object l'objet projet à supprimer
                locale : this.$route.params.locale,
                isVisible: false, // bool | la visibilité de la modale
                isSubmiting: false, // bool indique si le form de la modal est en cours de soumission

                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                // componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                // user: state => state.user
                organization: state => state.organization,
                themeToDisplay: state => state.app.themeToDisplay
            }),

            //----------------------------------------------

            // other computed props :
            // colorSelectorDefaultComputed: {
            //     get: function () {return this.colorSelectorDefault},
            //     set: function (newValue) {this.colorSelectorDefault = newValue}
            // }

        },
        // watch: {
        //     user: function () {
        //     }
        // },


        methods: {

            /*
            * Affiche la modale
            */
            showModal(){
                this.isVisible = true
            },

            /*
            * Masque la modale
            */
            hideModal(){
                this.isVisible = false
                this.isSubmiting=false
            }

            /**
             * Supprime un projet
             * @param projet Object projet à archiver
             */
            ,deleteProject(project){
                this.isSubmiting = true;

                let self = this
                return self.$http
                    .delete(`/organizations/${self.organizationSlug}/projects/${project.slug}`,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                      self.hideModal()

                        self.$root.$emit('project_deleted',project)

                        // tracking mixpanel
                        self.$mixpanel.track("Project deleted", {"timerecord":response.data.slug});
                        self.ga4GlobalEventTrack('Project deleted' , {})

                      return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0031'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error deleting project', 'fatal': false})
                          self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error deleting project"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error deleting project : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }


        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            /*
             * Event show_modal_delete_project, déclenche l'affichage de la modale
             */
            this.$root.$on('show_modal_delete_project', (project) => {
                this.project = project
                this.showModal()
            })

            /*
             * Event hide_modal_delete_project, masque la modale
             */
            this.$root.$on('hide_modal_delete_project', () => {
                this.hideModal()
            })



        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/
    // Les styles de ModalDeleteProjectComp et ModaleDeleteClientComp sont  mutualisé dans AppLayoutComp (voir .modalDeleteItem)

</style>
